module.exports = __webpack_public_path__ + "cx2.png?77183b0d6e68c170f29cda452d20f93d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cx2.png
// module id = 120
// module chunks = 0